module.exports = __webpack_public_path__ + "img/G9.88ee51a3.png";